export const MyPlanningTableStyle = {
  planningTableContainerMargin: {
    default: { margin: "10px  -15px" },
  },
  gravatarStyle: {
    default: { textAlign: "center", marginTop: "0px" },
  },
  statusStyle: {
    default: {
      padding: "5px",
      margin: "15px",
      borderRadius: "2px",
      color: "var(--fifth)",
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/styles/MyPlanningTableStyle.js